<template>
  <div style="margin: 6px 20px 20px 6px">
    <!-- was titled "Booking On-Time Performance Report", the same as the daily
         CM report -- a copy/paste holdover, corrected to name this page -->
    <FiPageRail title="Actuals - Multiday On-Time Performance Report">
      <template #actions><actuals-multiday-otp-help/></template>
    </FiPageRail>

    <div class="multiday-cm-filter-rows">
    <div class="multiday-cm-filter-row multiday-cm-toolbar">
      <b-button-group size="sm" class="multiday-cm-quick-range">
        <b-button
          v-for="opt in quick_range_options"
          :key="opt.value"
          :variant="quick_range_active_days === opt.value ? 'primary' : 'outline-secondary'"
          v-on:click.prevent="set_quick_range(opt.value)"
        >{{ opt.label }}</b-button>
      </b-button-group>
      <b-button-group class="toolbar-date-shifts">
        <b-button size="sm" variant="outline-secondary" class="toolbar-date-shift-btn" title="Previous month" v-on:click.prevent="shift_detail_graph_date(-1, 'months')"><i class="fa fa-angle-double-left" aria-hidden="true"></i></b-button>
        <b-button size="sm" variant="outline-secondary" class="toolbar-date-shift-btn" title="Previous day" v-on:click.prevent="shift_detail_graph_date(-1, 'days')"><i class="fa fa-angle-left" aria-hidden="true"></i></b-button>
      </b-button-group>
      <span class="toolbar-date-wrap">
        <date-picker class="toolbar-date" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      </span>
      <span class="toolbar-label">to</span>
      <span class="toolbar-date-wrap">
        <date-picker class="toolbar-date" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      </span>
      <b-button-group class="toolbar-date-shifts">
        <b-button size="sm" variant="outline-secondary" class="toolbar-date-shift-btn" title="Next day" v-on:click.prevent="shift_detail_graph_date(1, 'days')"><i class="fa fa-angle-right" aria-hidden="true"></i></b-button>
        <b-button size="sm" variant="outline-secondary" class="toolbar-date-shift-btn" title="Next month" v-on:click.prevent="shift_detail_graph_date(1, 'months')"><i class="fa fa-angle-double-right" aria-hidden="true"></i></b-button>
      </b-button-group>
      <b-button size="sm" class="toolbar-btn" v-on:click.prevent="load_data()" :disabled="loading">Run</b-button>
      <b-button size="sm" variant="success" class="toolbar-btn" :disabled="loading" @click="download">Download</b-button>
    </div>

    <div class="multiday-cm-filter-row multiday-cm-toolbar">
      <span v-if="base_options && base_options.length > 2" class="toolbar-group"><span class="toolbar-label">Yard</span><b-form-select size="sm" v-model="selected_base" :options="base_options" class="toolbar-select"/></span>
      <span v-if="client_options && client_options.length > 2" class="toolbar-group"><span class="toolbar-label">Client</span><b-form-select size="sm" v-model="selected_client" :options="client_options" class="toolbar-select"/></span>
      <span v-if="driver_options && driver_options.length > 2" class="toolbar-group"><span class="toolbar-label">Driver</span><b-form-select size="sm" v-model="selected_driver" :options="driver_options" class="toolbar-select"/></span>
      <span class="toolbar-group"><span class="toolbar-label">Early Limit</span><b-form-select size="sm" v-model="early_threshold" :options="threshold_options" class="toolbar-select toolbar-select-limit early"/></span>
      <span class="toolbar-group"><span class="toolbar-label">Late Limit</span><b-form-select size="sm" v-model="late_threshold" :options="threshold_options" class="toolbar-select toolbar-select-limit late"/></span>
    </div>

    <div v-if="!loading" class="multiday-cm-filter-chips actuals-filter-chips">
      <span
        class="actuals-chip actuals-chip-clickable actuals-chip-total"
        :class="{ 'actuals-chip-selected': selected_status == null }"
        @click="filter_by_status(null)"
      >{{ items.length }}/{{ summary.total_cnt }}</span>
      <span class="multiday-cm-filter-groups">
        <span class="multiday-cm-chip-group">
          <span class="actuals-filter-label">Type</span>
          <!-- no tint class: it's the reset, not one of the two type colors -->
          <span
            class="actuals-chip actuals-chip-clickable"
            :class="{ 'actuals-chip-selected': selected_type == null }"
            @click="filter_by_type(null)"
          >All Types</span>
          <span
            class="actuals-chip actuals-chip-clickable contract"
            :class="{ 'actuals-chip-selected': selected_type === 'contract' }"
            @click="filter_by_type('contract')"
          >Contract {{ summary.contract_cnt }}</span>
          <span
            class="actuals-chip actuals-chip-clickable private"
            :class="{ 'actuals-chip-selected': selected_type === 'private' }"
            @click="filter_by_type('private')"
          >Private {{ summary.private_cnt }}</span>
        </span>
        <span class="multiday-cm-chip-group">
          <span class="actuals-filter-label">Timing</span>
          <span
            class="actuals-chip actuals-chip-clickable ontime"
            :class="{ 'actuals-chip-selected': selected_status === 'ontime' }"
            @click="filter_by_status('ontime')"
          >On Time {{ ontime_items.length }}</span>
          <span
            class="actuals-chip actuals-chip-clickable early"
            :class="{ 'actuals-chip-selected': selected_status === 'early' }"
            @click="filter_by_status('early')"
          >Early {{ early_items.length }}</span>
          <span
            class="actuals-chip actuals-chip-clickable late"
            :class="{ 'actuals-chip-selected': selected_status === 'late' }"
            @click="filter_by_status('late')"
          >Late {{ late_items.length }}</span>
        </span>
      </span>
    </div>
    </div>

    <table v-if="!loading" class="multiday-cm-table" width="100%" border="1" cellpadding="2">
      <tr>
        <th colspan="5" style="font-size: 18px; font-weight: bold;">&nbsp;</th>
        <th style="background-color: lightgrey" colspan="3" v-for="time_field in summary.time_fields" @click="sort_dates('planned' + time_field + 'DateTime')">{{time_field}}</th>
      </tr>
      <tr>
        <th width="60px" @click="sort_numbers('charterID')">CharterID</th>
        <th width="60px" @click="sort_numbers('movementID')">MvmtID</th>
        <th width="60px" @click="sort_strings('clientID')">ClientID</th>
        <th width="60px" @click="sort_strings('vehicle')">Vehicle</th>
        <th width="60px" @click="sort_strings('driver')">Driver</th>
        <template v-for="time_field in summary.time_fields">
          <th width="60px" @click="sort_dates('planned' + time_field + 'DateTime')">Planned</th>
          <th width="60px" @click="sort_dates('actual' + time_field + 'DateTime')">Actual</th>
          <th width="30px" @click="sort_numbers(time_field + 'Delta')">Diff</th>
        </template>
      </tr>
      <template v-for="item in items">
        <tr>
          <td align="center">{{ item.charterID }}</td>
          <td align="center">
            <router-link style="font-weight: bold;" :to="{ path: '/actuals?booking_id=' + item.booking_hash }">{{ item.movementID }}</router-link>
          </td>
          <td align="center">{{ item.clientID }}</td>
          <td align="center">{{ item.vehicle }}</td>
          <td align="center">{{ item.driver }}</td>
          <template v-for="time in item.times">

            <td v-if="time.field=='Start' || time.field == 'Finish'">{{time.planned | formatDateTimeSmall}}</td>
            <td v-else>{{time.planned | formatTimeSmall}}</td>
            <td v-if="time.field=='Start' || time.field == 'Finish'">{{time.actual | formatDateTimeSmall}}</td>
            <td v-else>{{time.actual | formatTimeSmall}}</td>
            <td v-if="time.actual && time.delta < 0 && Math.abs(time.delta) > early_threshold" class="early">{{time.delta | units('m')}}</td>
            <td v-else-if="time.actual && time.delta > 0 && time.delta > late_threshold" class="late">{{time.delta | units('m')}}</td>
            <td v-else-if="time.delta">{{time.delta | units('m')}}</td>
            <td v-else>&nbsp;</td>
          </template>
        </tr>
      </template>
    </table>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>
<script>
import {api_url, get_actuals_multiday_otp_report, get_actuals_performance_report} from '../networking/apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import axios from "axios";
import actuals_multiday_otp_help from '@/components/actuals_multiday_otp_help'

export default {
  name: 'actuals_multiday_otp_report',

  components: {
    'actuals-multiday-otp-help': actuals_multiday_otp_help,
  },

  data() {
    return {
      booking_filter: '',
      items: [],
      ontime_items: [],
      early_items: [],
      late_items: [],
      summary: [],
      early_threshold: 10,
      late_threshold: 10,
      selected_base: null,
      selected_client: null,
      selected_driver: null,
      client_options: [],
      base_options: [],
      driver_options: [],
      selected_type: null,
      selected_status: null,
      quick_range_options: [
        { value: 1, label: '1 Day' },
        { value: 7, label: '7 Day' },
        { value: 30, label: '30 Day' },
      ],
      threshold_options: [
        { value: '1', text: '1m' },
        { value: '5', text: '5m' },
        { value: '10', text: '10m' },
        { value: '15', text: '15m' },
        { value: '20', text: '20m' },
        { value: '30', text: '30m' },
        { value: '45', text: '45m' },
        { value: '60', text: '1h' },
        { value: '120', text: '2h' },
        { value: '240', text: '4h' },
      ],
      loading: false,
      details_fromDate: justDate(moment().subtract(1, 'days')),
      details_toDate: justDate(moment().subtract(1, 'days')),

      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(360, 'days'),
        maxDate: moment().add(0, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  created() {
    this.load_data()
  },
  methods: {
    async load_data() {
      this.loading = true
      try {
        const {value: {data = []}} = await get_actuals_multiday_otp_report(this.user.tenant, this.selected_base, this.selected_client, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.base_options = data.summary.base_options
        this.client_options = data.summary.client_options
        this.buildDriverOptions()
        this.calc_otp_status()
        this.filter_items()
      } catch(e){
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    splitDrivers(driverField) {
      if (!driverField) return []
      return driverField.split(',').map(name => name.trim()).filter(Boolean)
    },
    itemHasDriver(item, driverName) {
      return this.splitDrivers(item.driver).includes(driverName)
    },
    buildDriverOptions() {
      const names = [...new Set((this.items_full || []).flatMap(item => this.splitDrivers(item.driver)))].sort()
      this.driver_options = [{ value: null, text: 'All Drivers' }, ...names.map(name => ({ value: name, text: name }))]
      if (this.selected_driver && !names.includes(this.selected_driver)) {
        this.selected_driver = null
      }
    },
    async calc_otp_status() {
      if (this.items && this.items.length > 0) {
        for (const item of this.items) {
          let otp_status = ''
          for (const time of item.times) {
            if (time.actual && time.delta < 0 && Math.abs(time.delta) > this.early_threshold) {
              otp_status += '+early'
            } else if (time.actual && time.delta > 0 && time.delta > this.late_threshold) {
              otp_status += '+late'
            }
          }
          if (otp_status == '')
              otp_status = 'ontime'
          item.otp_status = otp_status
        }
      }
      this.ontime_items = this.items_full.filter(item => item.otp_status.indexOf('ontime') != -1)
      this.early_items = this.items_full.filter(item => item.otp_status.indexOf('early') != -1)
      this.late_items = this.items_full.filter(item => item.otp_status.indexOf('late') != -1)
    },
    // both endpoints move together so the range length is preserved, and both are
    // clamped to the picker's own min/max. neither this nor set_quick_range triggers
    // a fetch: this report is Run-gated (unlike the actuals page, where the quick
    // ranges search immediately), so the user presses Run when the range is set.
    // shifts the whole window, then pins it inside the picker's min/max. the window
    // length is re-derived from `from` in days rather than shifting both endpoints
    // independently -- adding a month to each would let moment's end-of-month
    // clamping quietly shrink the range (Jan 1-30 would land on Feb 1-28).
    shift_report_range(shift, step_unit) {
      const from0 = moment(this.details_fromDate, 'MM-DD-YYYY')
      const to0 = moment(this.details_toDate, 'MM-DD-YYYY')
      const length = Math.max(0, to0.diff(from0, 'days'))
      const min = moment(this.options.minDate)
      const max = moment(this.options.maxDate)
      let from = from0.clone().add(shift, step_unit)
      let to = from.clone().add(length, 'days')
      if (to.isAfter(max, 'day')) {
        to = max.clone()
        from = to.clone().subtract(length, 'days')
      }
      if (from.isBefore(min, 'day')) {
        from = min.clone()
        to = from.clone().add(length, 'days')
        if (to.isAfter(max, 'day')) to = max.clone()
      }
      return { from, to }
    },
    // toDate is assigned first when moving forward so the details_fromDate watcher's
    // "from must not pass to" correction doesn't fire against the stale toDate
    apply_report_range(from, to, forward) {
      if (forward) {
        this.details_toDate = to.format('MM-DD-YYYY')
        this.details_fromDate = from.format('MM-DD-YYYY')
      } else {
        this.details_fromDate = from.format('MM-DD-YYYY')
        this.details_toDate = to.format('MM-DD-YYYY')
      }
    },
    shift_detail_graph_date(shift, unit) {
      const { from, to } = this.shift_report_range(shift, unit === 'months' ? 'months' : 'days')
      this.apply_report_range(from, to, shift > 0)
    },
    set_quick_range(days) {
      const max = moment(this.options.maxDate)
      const min = moment(this.options.minDate)
      let to = moment(this.details_toDate, 'MM-DD-YYYY')
      if (to.isAfter(max, 'day')) to = max.clone()
      let from = to.clone().subtract(days - 1, 'days')
      if (from.isBefore(min, 'day')) from = min.clone()
      this.apply_report_range(from, to, false)
    },
    filter_items() {
      this.items = this.items_full
      if (this.selected_type)
        this.items = this.items.filter(item => item.booking_type == this.selected_type)
      if (this.selected_base)
        this.items = this.items.filter(item => item.base == this.selected_base)
      if (this.selected_client)
        this.items = this.items.filter(item => item.clientID == this.selected_client)
      if (this.selected_driver)
        this.items = this.items.filter(item => this.itemHasDriver(item, this.selected_driver))
      if (this.selected_status)
        this.items = this.items.filter(item => item.otp_status.indexOf(this.selected_status) != -1)
      if (this.booking_filter)
        this.items = this.items.filter(item => (item.charterID.indexOf(this.booking_filter) != -1 || (item.driver != null && item.driver.indexOf(this.booking_filter) != -1) || (item.vehicle != null && item.vehicle.indexOf(this.booking_filter) != -1)))
    },
    filter_by_type(type) {
      if (type == null || this.selected_type == type) {
        this.selected_type = null
      } else {
        this.selected_type = type
      }
      this.filter_items()
    },
    filter_by_status(status) {
      if (status == null || this.selected_status == status) {
        this.selected_status = null
      } else {
        this.selected_status = status
      }
      this.filter_items()
    },
    sort_dates(col) {
      console.log("sort_dates:" + col)
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          // console.log("sort:" + a[col] + ", " + b[col])

          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return new Date(a[col]) - new Date(b[col])
          }
        })
      }
      this.sort_col = col
    },
    sort_numbers(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            return a[col] - b[col]
          }
        })
      }
      this.sort_col = col
    },
    sort_strings(col) {
      if (this.sort_col == col) {
        this.items = this.items.reverse()
      } else {
        this.items = this.items.sort((a, b) => {
          if (a[col] && !b[col]) {
            return -1
          } else if (!a[col] && b[col]) {
            return 1
          } else if (!a[col] && !b[col]) {
            return -1
          } else {
            let fa = a[col].charAt(0).toLowerCase(),
                fb = b[col].charAt(0).toLowerCase();

            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          }
        })
      }
      this.sort_col = col
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      const statusFilter = (this.selected_status === 'ontime' || this.selected_status === 'early' || this.selected_status === 'late') ? this.selected_status : null
      axios.post(
          `${api_url}bookings/reports/actuals/multiday/otp/download`,
          {
            tenant: this.user.tenant,
            base: this.selected_base,
            client: this.selected_client,
            booking_type: this.selected_type,
            driver: this.selected_driver || null,
            status: statusFilter,
            fromDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            toDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const tenantShort = this.user.tenant.split('-')[0]
        const bookingTypeSuffix = this.selected_type ? `-${this.selected_type}` : ''
        const statusSuffix = statusFilter ? `-${statusFilter}` : ''
        link.setAttribute(
            'download',
            `actuals-multiday-otp-${tenantShort}${bookingTypeSuffix}${statusSuffix}-${this.details_fromDate}-${this.details_toDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger', 5000)
      })
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    quick_range_active_days() {
      const from = moment(this.details_fromDate, 'MM-DD-YYYY')
      const to = moment(this.details_toDate, 'MM-DD-YYYY')
      return to.diff(from, 'days') + 1
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      if (moment(this.details_fromDate, 'MM-DD-YYYY') > moment(this.details_toDate, 'MM-DD-YYYY'))
        this.details_toDate = this.details_fromDate

      const days = moment(this.details_toDate, 'MM-DD-YYYY').diff(moment(this.details_fromDate, 'MM-DD-YYYY'),'days')
      if (days > 31) {
        alert("please limit tag based date range to 1 month or less")
        this.details_toDate = justDate(moment(this.details_fromDate, 'MM-DD-YYYY').add(1, 'month'))
      }
    },

    early_threshold(val) {
      this.calc_otp_status()
    },
    late_threshold(val) {
      this.calc_otp_status()
    },
    selected_base() {
      this.filter_items()
    },
    selected_client() {
      this.filter_items()
    },
    selected_driver() {
      this.filter_items()
    },
    booking_filter() {
      this.filter_items()
    },
  }
}
</script>

<style>
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }

.early-duration { background-color: hsla(120,100%,75%,0.2)}
.late-duration { background-color: rgba(255,0,0,0.2)}

.early { background-color: hsla(120,100%,75%,0.2)}
.late { background-color: rgba(255,0,0,0.2)}
.ontime { background-color: hsla(200,75%,50%,0.2)}
.private { background-color: hsla(200,40%,80%,0.2) }
.contract { background-color: hsla(250,60%,70%,0.2) }

.multiday-cm-filter-rows {
  display: flex;
  flex-direction: column;
  gap: 28px;
  margin-bottom: 28px;
}
.multiday-cm-filter-row {
  position: relative;
  font-weight: bold;
  font-size: 18px;
}
/* mirrors the actuals page toolbar (.actuals-cm-toolbar) so the date range reads
   the same on both; kept local rather than shared because those rules live inside
   actuals.vue's own block */
.multiday-cm-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 10px;
  font-size: 16px;
  font-weight: bold;
  /* the date picker drops below the row, so it needs to escape the row's stacking */
  z-index: 20;
  overflow: visible;
}
.multiday-cm-toolbar .toolbar-date-wrap {
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}
.multiday-cm-toolbar .toolbar-date-shifts,
.multiday-cm-quick-range {
  flex-shrink: 0;
}
.multiday-cm-toolbar .toolbar-date-shift-btn {
  padding: 0.15rem 0.35rem;
  line-height: 1;
  min-width: 1.75rem;
}
.multiday-cm-toolbar .toolbar-date-shift-btn .fa {
  font-size: 14px;
  font-weight: bold;
  vertical-align: middle;
}
.multiday-cm-toolbar .toolbar-date {
  font-size: 16px;
  font-weight: bold;
  width: 118px;
  padding: 0.25rem 0.5rem;
  height: calc(1.5em + 0.5rem + 2px);
}
.multiday-cm-toolbar .toolbar-select {
  font-size: 16px;
  font-weight: bold;
  width: 200px;
}
.multiday-cm-toolbar .toolbar-select-limit { width: 90px; }
.multiday-cm-toolbar .toolbar-label {
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  color: #6c757d;
}
.multiday-cm-toolbar .toolbar-btn { flex-shrink: 0; }
.multiday-cm-toolbar .toolbar-group {
  display: inline-flex;
  align-items: center;
  gap: 6px 8px;
  flex-shrink: 0;
}
/* no horizontal inset so the row can use the table's full width, with the whole
   set of filters centered in it. the compound selector outranks the global
   `.actuals-filter-chips { justify-content: flex-start }` (from actuals.vue)
   rather than relying on which of the two lands later in the bundle. */
.multiday-cm-filter-chips.actuals-filter-chips {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 7px 9px;
}
/* holds the type + timing groups together so they keep a wider gap between them
   than between their own chips, and wrap as a unit */
.multiday-cm-filter-groups {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 7px 14px;
}
.multiday-cm-chip-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px 9px;
}
/* the chip base classes (.actuals-chip, .actuals-filter-label/-sep) are not
   redeclared here: they already resolve globally from the unscoped blocks in
   actuals.vue and the TBN reports, so this page picks up exactly the same chips
   its siblings render. */

/* horizon: the `border="1"` browser bevel this report family relies on reads
   washed out, and the shaded Diff cells lose their edges to the `.early`/`.late`
   fills above -- so draw a definite collapsed grid instead. scoped to the theme
   because classic is meant to stay pixel-identical, and midnight already re-inks
   table[border] in midnight.css. */
[data-fi-theme="new"] .multiday-cm-table {
  border-collapse: collapse;
  border: 2px solid #7a8089;
}
[data-fi-theme="new"] .multiday-cm-table th,
[data-fi-theme="new"] .multiday-cm-table td {
  border: 1px solid #7a8089;
}

</style>
